/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPccPatientDetailsResponse
 */
export interface UploadPccPatientDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadPccPatientDetailsResponse
     */
    patient_id: string;
}

/**
 * Check if a given object implements the UploadPccPatientDetailsResponse interface.
 */
export function instanceOfUploadPccPatientDetailsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;

    return isInstance;
}

export function UploadPccPatientDetailsResponseFromJSON(json: any): UploadPccPatientDetailsResponse {
    return UploadPccPatientDetailsResponseFromJSONTyped(json, false);
}

export function UploadPccPatientDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPccPatientDetailsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
    };
}

export function UploadPccPatientDetailsResponseToJSON(value?: UploadPccPatientDetailsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
    };
}

